import * as React from 'react'
import { Button, Dialog, Intent } from '@blueprintjs/core'
import { useState } from 'react'

interface Props {
  title: string
  body: string | React.ReactElement
  submitButtonIntent?: Intent
  isOpen: boolean
  onClose: () => void
  onSubmit: () => void
}

export const UnlockForPickingConfirmation = ({
  title,
  body,
  submitButtonIntent = Intent.WARNING,
  onSubmit,
  isOpen,
  onClose
}: Props) => {
  const [loading, setLoading] = useState(false)

  const handleSubmit = async () => {
    setLoading(true)
    try {
      await onSubmit()
    } finally {
      setLoading(false)
      onClose()
    }
  }

  return (
    <>
      <Dialog title={title} hasBackdrop={false} isOpen={isOpen} onClose={onClose}>
        <div className="bp3-dialog-body">
          <span>{body}</span>
        </div>
        <div className="bp3-dialog-footer">
          <div className="bp3-dialog-footer-actions">
            <Button onClick={onClose} minimal>
              Cancel
            </Button>
            <Button
              onClick={() => {
                handleSubmit()
              }}
              intent={submitButtonIntent}
              loading={loading}
            >
              Unlock
            </Button>
          </div>
        </div>
      </Dialog>
    </>
  )
}
